// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout_main__Dijnb","mainLanding":"Layout_mainLanding__dD76J","mainBlank":"Layout_mainBlank__3JlrE","mainCenterBlank":"Layout_mainCenterBlank__qaW5h"};